<template>
  <div>
    <div v-if="workDone">
      <h3 class="w-full text-center">
        <div class="w-full md:text-left text-center" v-if="oneDayRange">
          <span class="font-bold">{{periodRange.from | dateWord}}</span></div>
        <div class="w-full">
          <div>
            <span class="font-bold">{{this.periodName}}</span>
          </div>
          <!-- <div> -->
              <!-- ({{periodRange.from | dateWord}} - {{periodRange.to | dateWord}}) -->
          <!-- </div> -->
        </div>
      </h3>

      <div class="md:flex content-center mt-4">
        <div class="md:w-3/5 md:px-8">
          <span class="font-black text-black text-5xl md:text-6xl mb-2">review</span>

          <div v-if="noWorkDone" class="flex flex-col items-center text-black md:mx-16">
            <div class="md:w-2/3 w-1/2">
              <img src="@/assets/images/empty/review_empty.png"/>
            </div>

            <p class="text-center font-bold text-3xl mb-4">
              In this time period, you have not tracked anything
            </p>

            <p class="text-center mb-4">
              It may not seem important now, but in a month or later, you will not remember what you have done, what went well, what went not so well. Do not miss essential data about your progress, do not limit yourself.
            </p>

            <p class="text-center font-bold">
              What gets measured gets improved.
            </p>
          </div>
          <div v-else>
            <div class="w-full mb-8">
              <Stats :from="from" :to="to"/>
            </div>

            <div class="flex flex-col">
              <div v-if="anyGoals" class="mb-6">
                <div class="flex items-center text-black">
                  <feather-icon icon="TargetIcon" svgClasses="h-5 w-5" class="mr-2"/>
                  <span class="font-bold text-xl">
                    Goals
                  </span>
                </div>
                <div class="w-full">
                  <WorkChip v-for="goal in workDone.goals"  :title="goal.title" :backgroundColor="goal.backgroundColor" :key="goal.id"/>
                </div>
              </div>

              <div v-if="anyTasks" class="mb-6">
                <div class="flex items-center text-black">
                  <feather-icon icon="CheckSquareIcon" svgClasses="h-5 w-5" class="mr-2"/>
                  <span class="font-bold text-xl">
                    Tasks
                  </span>
                </div>


                <div class="w-full mb-4">
                  <WorkChip v-for="task in workDone.tasks"  :title="task.title"  :backgroundColor="task.backgroundColor" :key="task.id"/>
                </div>
              </div>

              <div v-if="anyRoutines" class="mb-6">
                <div class="flex items-center text-black">
                  <feather-icon icon="RefreshCwIcon" svgClasses="h-5 w-5" class="mr-2"/>
                  <span class="font-bold text-xl">
                    Routine
                  </span>
                </div>

                <div class="w-full mb-4">
                  <WorkChip v-for="countedRoutine in workDone.countedRoutines"  :title="countedRoutine.routine.title" :count="countedRoutine.count" :backgroundColor="countedRoutine.routine.backgroundColor" :key="countedRoutine.routine.id"/>
                </div>
              </div>
            </div>
          </div>
        </div>


        <div class="md:px-8 md:w-2/5 mt-8 md:mt-0 flex flex-col justify-center">

          <span class="font-black text-black text-5xl md:text-6xl mb-2">reflect</span>
          <div class="font-bold text-black">
            Think back on what happened in this period and appreciate the good things or find ways to improve not-so-good ones.
          </div>

          <div class="font-italic mt-2">
            Learning doesn't come out of experience but from reflecting on experience.
          </div>

          <div class="font-bold mt-6 text-black">
            I would rate this period as ...
          </div>
          <div class="flex justify-start">
           <div class="mt-2">
              <vs-radio vs-name="good" color="dark" class="mr-3" v-model="reviewLocal.sentiment" vs-value="good">good</vs-radio>
              <vs-radio vs-name="not_so_good" color="dark" class="mr-3" v-model="reviewLocal.sentiment" vs-value="not_so_good">not so good</vs-radio>
           </div>
         </div>

          <vs-input
            :key="reflection.question"
            v-for="reflection in reviewLocal.reflections"
            color="dark"
            :label="reflection.question"
            :placeholder="reflection.placeholder"
            v-model="reflection.answer"
            name="title"
            class="w-full mt-4"
            autocomplete="off"
          />
          </div>
        </div>

        <div class="flex w-full justify-end flex-wrap mt-4">
          <vs-button @click.stop="save" class="mt-2 shadow">
            complete reflection
          </vs-button>
          </div>
        </div>
      <div v-else>
        <Loader/>
      </div>
  </div>
</template>

<script>
// import DateHelper from '@/helpers/date'
import { FormWizard, TabContent } from 'vue-form-wizard'
import Loader from '../Generic/Loader'
import * as DateHelper from '@/helpers/date'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import TasksReview from './Tasks'
import WorkChip from '../Journey/WorkChip'
import Stats from '../Journey/Stats'
import _ from 'lodash'

export default {
  components: {
    FormWizard,
    TabContent,
    Loader,
    TasksReview,
    WorkChip,
    Stats
  },
  props: ['review'],
  data () {
    return {
      popupActive: false,
      workDone: null,
      overdueWork: null,
      reviewLocal: {}
    }
  },
  watch: {
    review: {
      immediate: true,
      async handler (review) {
        if (!review) return

        console.log('review.id', review.id, review.to)
        this.reviewLocal = _.merge({}, review)
        this.loadData()
      }
    },
  },
  methods: {
    loadData () {
      this.workDone = null
      this.$store.dispatch('computeReviewData', { from: this.from, to: this.to }).then(
        (computed) => {
          console.log('computed', computed)
          this.workDone = computed
        }
      )
      return true
    },
    save () {
      if (this.edit) {
        const { reflections, sentiment } = this.reviewLocal
        this.$store.dispatch('UPDATE_REVIEW', { review: this.review, updateFields: {reflections, sentiment } })
      } else {
        this.$store.dispatch('ADD_REVIEW', { review: this.reviewLocal })

        this.$store.dispatch('ADDITIONAL_USER_INFO', { reviewCreated: true })
        this.$store.dispatch('ADDITIONAL_USER_INFO', { lastReviewEndAt: this.to })
      }

      // trackAnalytics(this, 'app_action', this.edit ? 'update_goal' : 'add_goal', null, this.$store.getters.daysFromRegistration)
      this.$emit('close')
    }
  },
  mounted () {
  },
  computed: {
    noWorkDone () {
      // return true
      return this.workDone &&
        !this.anyTasks &&
        !this.anyRoutines &&
        !this.anyGoals
    },
    edit () {
      return !!_.get(this.review, 'id')
    },
    from () {
      return this.review.from
    },
    to () {
      return this.review.to
    },
    periodName () {
      return DateHelper.periodWord(this.review.from, this.review.to)
    },
    oneDayRange () {
      return DateHelper.areEqual(this.from, this.to)
    },
    anyTasks () {
      return this.workDone && this.workDone.tasks.length > 0
    },
    anyRoutines () {
      return this.workDone && this.workDone.countedRoutines.length > 0
    },
    anyGoals () {
      return this.workDone && this.workDone.goals.length > 0
    }
  },

}
</script>
